export default __webpack_public_path__ + "static/media/img-2.2f07fc38.jpg";